@if (!isInternalUser() && vehicles()) {
	<ui-notify
		data-cy="subscription-notify"
		[showBottomPadding]="false"
		[text]="vehicles() | subscriptionNotifyTranslation: singularTranslation() : pluralTranslation()"
		[type]="notifyType()"
	>
		<subscription-renewal-button
			[userEmail]="userEmail()"
			[userName]="userName()"
		></subscription-renewal-button>
	</ui-notify>
}
